import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CommonModule, NgOptimizedImage } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { BtnModakComponent } from '@shared/components/dumb/button/button.component';
import { StaticServeModule } from '@core/static-serve/static-serve.module';

@Component({
  selector: 'mdk-dialog-qr-download-app',
  standalone: true,
  imports: [CommonModule, NgOptimizedImage, TranslateModule, BtnModakComponent, StaticServeModule],
  templateUrl: './dialog-qr-download-app.component.html',
  styleUrls: [
    './styles/dialog-qr-download-app.component.mobile.scss',
    './styles/dialog-qr-download-app.component.desktop.scss',
  ]
})
export class DialogQrDownloadAppComponent {
  //#region [---- [INPUTS] ----]
  @Input() name: string
  @Input() phone: string
  @Input() showCloseIcon: boolean = true
  //#endregion

  //#region [---- [OUTPUTS] ----]
  @Output() hideModal: EventEmitter<void> = new EventEmitter<void>();
  //#endregion

  //#region [---- [EVENTS] -----]
  public done(): void {
    this.hideModal.emit()
  }
  //#endregion

}
